import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import TextareaAutosize from 'react-autosize-textarea';
import { analyticsTrack } from '../../../analyticsUtils';
import { postRequest, getRequest, deleteRequest } from '../../../requestUtils';
import infoIcon from '../../../../assets/images/icons/blue-info-icon.svg';
import loading from '../../../../assets/images/spinner-DNA-2s-200px.svg';
import './ScreeningQuestions.scss';
var processQuestionsParams = function processQuestionsParams(questions, projectId) {
  return questions.map(function (question) {
    return _objectSpread(_objectSpread({}, question), {}, {
      project_id: projectId
    });
  });
};
var ScreeningQuestions = /*#__PURE__*/function (_Component) {
  function ScreeningQuestions() {
    var _this;
    _classCallCheck(this, ScreeningQuestions);
    _this = _callSuper(this, ScreeningQuestions);
    _this.state = {
      questions: [],
      errors: [],
      isFetching: false,
      isProcessing: false,
      editWarning: false,
      editIds: [],
      processingError: ''
    };
    _this.renderQuestionInput = _this.renderQuestionInput.bind(_this);
    _this.handleOnChange = _this.handleOnChange.bind(_this);
    _this.handleAddQuestion = _this.handleAddQuestion.bind(_this);
    _this.handleRemoveQuestion = _this.handleRemoveQuestion.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.getScreeningQuestions = _this.getScreeningQuestions.bind(_this);
    _this.renderButtons = _this.renderButtons.bind(_this);
    _this.handleEditQuestion = _this.handleEditQuestion.bind(_this);
    return _this;
  }
  _inherits(ScreeningQuestions, _Component);
  return _createClass(ScreeningQuestions, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getScreeningQuestions();
      analyticsTrack('Viewed screening questions tab', {
        location: 'Projects view'
      });
    }
  }, {
    key: "getScreeningQuestions",
    value: function () {
      var _getScreeningQuestions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var force,
          projectId,
          response,
          _response$data,
          questions,
          editWarning,
          _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              force = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
              projectId = this.props.projectId;
              this.setState({
                isFetching: true,
                processingError: ''
              });
              _context.prev = 3;
              _context.next = 6;
              return getRequest("/project_screening_questions".concat(force ? '/fetch_from_ai' : ''), {
                project_id: projectId
              });
            case 6:
              response = _context.sent;
              _response$data = response.data, questions = _response$data.screening_questions, editWarning = _response$data.edit_warning;
              this.setState({
                questions: questions,
                editWarning: editWarning,
                editIds: force ? _toConsumableArray(Array(questions.length).keys()) : [],
                isFetching: false
              });
              _context.next = 14;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](3);
              this.setState({
                processingError: 'There was an error processing your request. Try again.',
                isFetching: false,
                error: _context.t0
              });
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[3, 11]]);
      }));
      function getScreeningQuestions() {
        return _getScreeningQuestions.apply(this, arguments);
      }
      return getScreeningQuestions;
    }()
  }, {
    key: "handleOnChange",
    value: function handleOnChange(value, index) {
      var _this$state = this.state,
        questions = _this$state.questions,
        errors = _this$state.errors;
      var newQuestions = _toConsumableArray(questions);
      var newError = _toConsumableArray(errors);
      newError[index] = '';
      newQuestions[index].question_text = value;
      this.setState({
        questions: newQuestions,
        errors: newError
      });
    }
  }, {
    key: "handleAddQuestion",
    value: function handleAddQuestion() {
      var questions = this.state.questions;
      if (questions.length < 4) {
        this.setState({
          questions: [].concat(_toConsumableArray(questions), [{
            question_text: ''
          }]),
          editIds: _toConsumableArray(Array(questions.length + 1).keys())
        });
      }
    }
  }, {
    key: "handleRemoveQuestion",
    value: function () {
      var _handleRemoveQuestion = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(index) {
        var _this$state2, questions, editWarning, _this$props, csrfToken, updateNextSteps, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this$state2 = this.state, questions = _this$state2.questions, editWarning = _this$state2.editWarning;
              _this$props = this.props, csrfToken = _this$props.csrfToken, updateNextSteps = _this$props.updateNextSteps;
              if (!questions[index].id) {
                _context2.next = 16;
                break;
              }
              _context2.prev = 3;
              _context2.next = 6;
              return deleteRequest("/project_screening_questions/".concat(questions[index].id), csrfToken);
            case 6:
              response = _context2.sent;
              this.updateQuestion(index, response.data.edit_warning);
              updateNextSteps(response.data.next_steps);
              _context2.next = 14;
              break;
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](3);
              // Handle error silently or with a notification
              this.setState({
                error: _context2.t0
              });
            case 14:
              _context2.next = 17;
              break;
            case 16:
              this.updateQuestion(index, editWarning);
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[3, 11]]);
      }));
      function handleRemoveQuestion(_x) {
        return _handleRemoveQuestion.apply(this, arguments);
      }
      return handleRemoveQuestion;
    }()
  }, {
    key: "updateQuestion",
    value: function updateQuestion(index, editWarning) {
      var _this$state3 = this.state,
        questions = _this$state3.questions,
        errors = _this$state3.errors,
        editIds = _this$state3.editIds;
      var newEditIds = _toConsumableArray(Array(editIds.length - 1).keys());
      var newQuestions = [].concat(_toConsumableArray(questions.slice(0, index)), _toConsumableArray(questions.slice(index + 1)));
      var newError = [].concat(_toConsumableArray(errors.slice(0, index)), _toConsumableArray(errors.slice(index + 1)));
      this.setState({
        questions: newQuestions,
        errors: newError,
        editIds: newEditIds,
        editWarning: editWarning
      });
    }
  }, {
    key: "handleEditQuestion",
    value: function handleEditQuestion() {
      var questions = this.state.questions;
      this.setState({
        editIds: _toConsumableArray(Array(questions.length).keys())
      });
    }
  }, {
    key: "handleSubmit",
    value: function () {
      var _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var questions, _this$props2, csrfToken, projectId, updateNextSteps, processedParams, isValid, errors, response, _response$data2, nextSteps, screening_questions, edit_warning;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              questions = this.state.questions;
              _this$props2 = this.props, csrfToken = _this$props2.csrfToken, projectId = _this$props2.projectId, updateNextSteps = _this$props2.updateNextSteps;
              processedParams = processQuestionsParams(questions, projectId);
              isValid = true;
              errors = questions.map(function (question) {
                if (question.question_text.length < 10) {
                  isValid = false;
                  return 'Question must contain at least 10 characters.';
                }
                return null;
              });
              if (isValid) {
                _context3.next = 8;
                break;
              }
              this.setState({
                errors: errors
              });
              return _context3.abrupt("return");
            case 8:
              this.setState({
                isProcessing: true,
                processingError: ''
              });
              _context3.prev = 9;
              _context3.next = 12;
              return postRequest('/project_screening_questions', {
                screening_questions: processedParams,
                project_id: projectId
              }, csrfToken);
            case 12:
              response = _context3.sent;
              _response$data2 = response.data, nextSteps = _response$data2.next_steps, screening_questions = _response$data2.screening_questions, edit_warning = _response$data2.edit_warning;
              this.setState({
                questions: screening_questions,
                isProcessing: false,
                editWarning: edit_warning,
                editIds: []
              });
              updateNextSteps(nextSteps);
              _context3.next = 21;
              break;
            case 18:
              _context3.prev = 18;
              _context3.t0 = _context3["catch"](9);
              this.setState({
                processingError: 'There was an error processing your request. Try again.',
                isProcessing: false,
                error: _context3.t0
              });
            case 21:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[9, 18]]);
      }));
      function handleSubmit() {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }()
  }, {
    key: "renderButtons",
    value: function renderButtons() {
      var _this$state4 = this.state,
        questions = _this$state4.questions,
        editIds = _this$state4.editIds,
        isProcessing = _this$state4.isProcessing;
      if (questions.length > 0 && editIds.length > 0) {
        return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: "add-question-button"
        }, /*#__PURE__*/React.createElement("button", {
          className: questions.length >= 4 ? 'disabled' : 'active',
          onClick: this.handleAddQuestion
        }, "+ Add new")), /*#__PURE__*/React.createElement("div", {
          className: "max-question-text"
        }, "4 questions max."), /*#__PURE__*/React.createElement("div", {
          className: "save-button"
        }, /*#__PURE__*/React.createElement("button", {
          className: isProcessing && 'saving',
          onClick: this.handleSubmit
        }, isProcessing ? 'Saving...' : 'Save')));
      }
      if (questions.length === 0 && editIds.length === 0) {
        return /*#__PURE__*/React.createElement("div", {
          className: "add-own-button"
        }, /*#__PURE__*/React.createElement("button", {
          onClick: this.handleAddQuestion
        }, "Add My Own"));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "edit-button"
      }, /*#__PURE__*/React.createElement("button", {
        className: "active'",
        onClick: this.handleEditQuestion
      }, "Edit"));
    }
  }, {
    key: "renderQuestionInput",
    value: function renderQuestionInput(question, index, error) {
      var _this2 = this;
      var editIds = this.state.editIds;
      return /*#__PURE__*/React.createElement("div", {
        className: "question-container",
        key: index
      }, editIds.includes(index) ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("label", {
        htmlFor: "Question ".concat(index + 1)
      }, /*#__PURE__*/React.createElement("span", {
        className: "header"
      }, "Question ".concat(index + 1)), /*#__PURE__*/React.createElement(TextareaAutosize, {
        value: question.question_text,
        required: question.length < 3,
        rows: 3,
        onChange: function onChange(event) {
          return _this2.handleOnChange(event.target.value, index);
        },
        id: "question_".concat(index + 1)
      })), /*#__PURE__*/React.createElement("div", {
        className: "footer"
      }, /*#__PURE__*/React.createElement("span", {
        className: "error"
      }, error && error), /*#__PURE__*/React.createElement("button", {
        id: "remove-question-".concat(index + 1),
        onClick: function onClick() {
          return _this2.handleRemoveQuestion(index);
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-trash-alt"
      }), "Remove"))) : /*#__PURE__*/React.createElement("div", {
        className: "question-display"
      }, /*#__PURE__*/React.createElement("div", {
        className: "question"
      }, /*#__PURE__*/React.createElement("h3", {
        className: "header mb-3"
      }, "Question ".concat(index + 1)), question.question_text), /*#__PURE__*/React.createElement("button", {
        id: "edit-question-".concat(index + 1),
        onClick: this.handleEditQuestion
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-edit"
      }))));
    }
  }, {
    key: "renderQuestionInfo",
    value: function renderQuestionInfo() {
      var _this3 = this;
      var editWarning = this.state.editWarning;
      return /*#__PURE__*/React.createElement(Fragment, null, editWarning && /*#__PURE__*/React.createElement("div", {
        className: "info-blurb"
      }, /*#__PURE__*/React.createElement("img", {
        src: infoIcon,
        alt: "info-icon"
      }), /*#__PURE__*/React.createElement("div", {
        className: "message"
      }, /*#__PURE__*/React.createElement("h3", null, "Some applicants are already in the screening pipeline."), /*#__PURE__*/React.createElement("span", {
        className: "mb-2"
      }, "To ensure a fair and consistent assessment, consider the timing of edits carefully"), /*#__PURE__*/React.createElement("span", null, "For guidance on modifying questions without affecting applicant experience, please contact Clora via chat or email."))), /*#__PURE__*/React.createElement("div", {
        className: "info-blurb"
      }, /*#__PURE__*/React.createElement("img", {
        src: infoIcon,
        alt: "info-icon"
      }), /*#__PURE__*/React.createElement("div", {
        className: "message"
      }, /*#__PURE__*/React.createElement("h3", null, "Draft questions with AI", /*#__PURE__*/React.createElement("span", {
        role: "img",
        "aria-label": "star-emoji"
      }, " \u2728")), /*#__PURE__*/React.createElement("span", null, "Need help drafting questions? Get AI to draft your questions."), /*#__PURE__*/React.createElement("button", {
        onClick: function onClick() {
          return _this3.getScreeningQuestions(true);
        }
      }, "Add AI suggestions"))));
    }
  }, {
    key: "renderQuestions",
    value: function renderQuestions() {
      var _this4 = this;
      var _this$state5 = this.state,
        questions = _this$state5.questions,
        errors = _this$state5.errors;
      return /*#__PURE__*/React.createElement(Fragment, null, questions.map(function (question, index) {
        return _this4.renderQuestionInput(question, index, errors[index]);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state6 = this.state,
        questions = _this$state6.questions,
        isFetching = _this$state6.isFetching,
        processingError = _this$state6.processingError;
      return /*#__PURE__*/React.createElement("div", {
        className: "g-flex-8 project-info-column screening-questions-container"
      }, isFetching ? /*#__PURE__*/React.createElement("div", {
        className: "loading"
      }, /*#__PURE__*/React.createElement("img", {
        src: loading,
        alt: "Loading_image"
      })) : /*#__PURE__*/React.createElement("div", {
        className: "screening-questions-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "project-summary-card-header"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "project-section-title"
      }, "Screening Questions")), /*#__PURE__*/React.createElement("div", {
        className: "applicants-info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "info-header"
      }, "Ask questions that matter."), /*#__PURE__*/React.createElement("div", {
        className: "message"
      }, "Applicants will answer these questions during the application process for you to use as screening criteria. If no questions are added here, you will receive a resume and a brief summary of their experience.")), this.renderQuestionInfo(), questions.length === 0 && /*#__PURE__*/React.createElement("span", {
        className: "empty-question"
      }, "No questions have been added yet."), this.renderQuestions(), this.renderButtons(), /*#__PURE__*/React.createElement("div", {
        className: "g-row g-row--centered warning-text"
      }, processingError && /*#__PURE__*/React.createElement("span", null, processingError))));
    }
  }]);
}(Component);
ScreeningQuestions.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  projectId: PropTypes.number.isRequired,
  updateNextSteps: PropTypes.func.isRequired
};
ScreeningQuestions.defaultProps = {};
export default ScreeningQuestions;